import { useLocalSearchParams } from 'expo-router'

import { AvatarScreen } from '@/src/features/settings/ui/screens/AvatarScreen'

export default () => {
  const { id } = useLocalSearchParams<{ id: string }>()
  return <AvatarScreen id={id} />
}
